module.exports = __webpack_public_path__ + "a88ab089be2554285b95149fa1645eb4.pdf";